module.exports = __webpack_public_path__ + "static/media/background-login.cc661bc4.jpg";